import * as React from 'react';

import { IStore } from '../../model';

import { StoreStockAvailability } from './StoreStockAvailability';
import { StoreDescription, StoreTitle } from './styled';

interface IStoreProps {
  data: IStore;
}

export const Store: React.FC<IStoreProps> = ({ data }) => {
  return (
    <>
      <StoreTitle>{data.name}</StoreTitle>
      <StoreDescription
        dangerouslySetInnerHTML={{
          __html: data.description,
        }}
      />
      <StoreStockAvailability {...data} />
    </>
  );
};
